import React from "react";
import PropTypes from "prop-types";
import styles from "./HeaderBlock.module.css";

export default function HeaderBlock({ data = {} }) {
  const text = data?.text ?? false;
  const subHeading = data?.["sub-heading"] ?? false;

  if (!text && !subHeading) return null;

  return (
    <div className={styles.header}>
      {text && <h1>{text}</h1>}
      {subHeading && <p>{subHeading}</p>}
    </div>
  );
}

HeaderBlock.propTypes = {
  data: PropTypes.shape({
    "text": PropTypes.string.isRequired,
    "sub-heading": PropTypes.string.isRequired,
  }),
};
